import { TFunction } from 'i18next';
import * as yup from 'yup';

import { validatePhoneNumber } from '@/shared/lib/libphonenumber';

const useCrewFormHook = () => {
  // TODO: update validations functions
  // TODO: refactor this into a more stable validation function
  const fileValidation = (t: TFunction<'common', undefined>) =>
    yup
      .mixed()
      .test('fileType', t('unsupported image format'), (value) => {
        if (!value) return true; // No validation if empty
        if (typeof value === 'string') return true; // Assume URLs are valid

        const fileT = value?.file;
        if (!fileT) return true; // No validation if no file

        // Allowed file types
        const validTypes = [
          'image/jpeg',
          'image/png',
          'image/gif',
          'image/svg+xml',
          'image/webp',
        ];

        return validTypes.includes(fileT.type);
      })
      .test(
        'fileResolution',
        t('unsupported image resolution'),
        async (value) => {
          if (!value || typeof value === 'string') return true; // No validation for URLs

          const fileT = value?.file;
          if (!fileT) return true;

          const image = await new Promise<{ width: number; height: number }>(
            (resolve, reject) => {
              const img = new Image();
              img.onload = () =>
                resolve({ width: img.width, height: img.height });
              img.onerror = reject;
              img.src = URL.createObjectURL(fileT);
            }
          );

          // General resolution check (example: allow at least 300x300)
          return image.width >= 300 && image.height >= 300;
        }
      )
      .test('fileSize', t('image-too-large'), (value) => {
        if (!value || typeof value === 'string') return true; // No validation for URLs

        const fileT = value?.file;
        if (!fileT) return true;

        // General max file size (e.g., 2MB)
        return fileT.size <= 2_000_000;
      })
      .optional();

  const crewValidationSchema = (t: TFunction<'common', undefined>) =>
    yup.object().shape({
      phoneNumber: yup
        .string()
        .notRequired()
        .nullable()
        .test('isValidPhoneNumber', t('wrong-phone-number'), (value) =>
          validatePhoneNumber(value, false)
        ),
      nationalIdFront: fileValidation(t),
      nationalIdBack: fileValidation(t),
      name: yup
        .string()
        .required(t('this-field-is-required'))
        .max(
          50,
          t('this-field-not-accept-more-than-x-character', { count: 50 })
        ),
    });

  const workerValidationSchema = (
    t: TFunction<'common', undefined>,
    hasFaceRecognition?: boolean
  ) =>
    crewValidationSchema(t).shape({
      nationalIdNumber: yup
        .mixed()
        .test(
          'is-number',
          'Must be a number',
          (value) => !value || !isNaN(Number(value))
        )
        .notRequired()
        .nullable(),
      profilePicture: yup.mixed().when(String(hasFaceRecognition), {
        is: true,
        then: fileValidation(t),
      }),
      customId: yup
        .mixed()
        .test(
          'is-number',
          'Must be a number',
          (value) => !value || !isNaN(Number(value))
        )
        .notRequired()
        .nullable(),
    });

  return {
    crewValidationSchema,
    workerValidationSchema,
  };
};
export default useCrewFormHook;
